var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'tw-flex tw-relative tw-justify-center tw-cursor-pointer focus:tw-shadow-outline tw-rounded-full tw-p-2 tw--m-2 tw-items-center tw-transition-color tw-duration-75 focus:tw-outline-none',
    _vm.colorClass,
  ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('base-spinner',{attrs:{"color":"currentColor","size":20}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }